import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchData, CREATE_FORUM, GET_FORUM_SUB_CATEGORY } from "../../components/Service";
import { toast } from "react-toastify";
import { Context } from "../../components/Context";
import Select from "react-select";
import {useNavigate,} from "../../../node_modules/react-router-dom/dist/index";

const CreateForum = (props) => {
	const [context] = useContext(Context);
	const [catId, setCatId] = useState();
	const [subCat, setSubCat] = useState([]);
	const [selectedCat, setSelectedCat] = useState(null);
	const [selectedSubCat, setSelectedSubCat] = useState(null);
    const navigate = useNavigate();
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		reset,
		trigger,
	} = useForm({ mode: "onChange" });

	const getSubCategory = (category_id) => {
		let value = {
			category_id: category_id,
		};

		fetchData(GET_FORUM_SUB_CATEGORY, "POST", value, false, false, (res) => {
			if (res.status) {
				setSubCat(res?.data);
			} else {
				setSubCat([]);
			}
		});
	};

	const createData = (data) => {
		data = {
			user_id: context?.user?.user_id,
			country_id: context?.countryId,
			state_id: context?.stateId,
			...data,
		};

		fetchData(CREATE_FORUM, "POST", data, true, false, (res) => {
			if (res.status) {
				toast.success("Forum created successfully.");
				navigate(`/profile?tab=ads`);
				reset();

				window.$("#createForumModal").modal("hide");
			} else {
				toast.error("Unable to create forum.");
			}
		});
	};

	useEffect(() => {
		getSubCategory(catId);
	}, [catId]);

	return (
		<div
			className="modal fade pe-0"
			id="createForumModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabIndex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content">
					<button
						className="btn-close"
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={() => {
							reset();
							setSelectedCat(null);
							setValue("category_id", "");
							setSelectedSubCat(null);
							setValue("sub_cat_id", "");
						}}
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<h5 className="text-brand-1 text-capitalize">Create Forum</h5>
					</div>
					<div className="modal-body px-4 px-xl-5 py-3">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(createData)}>
							<div className="row">
								<div className="col-12 mb-2">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.title && "is-invalid"}`}
										placeholder="Title"
										maxLength={60}
										{...register("title", {
											required: { value: true, message: "Title is required." },
										})}
									/>
									{errors.title && <div className="invalid-feedback">{errors.title.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Category <span className="text-danger">*</span>
									</label>

									<Select
										{...register("category_id", {
											required: { value: true, message: "Select a category." },
										})}
										options={props?.categoryList?.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										value={selectedCat}
										onChange={(selected) => {
											setSelectedCat(selected);
											setCatId(selected ? selected.value : "");
											setValue("category_id", selected ? selected.value : "");
											trigger("category_id");
										}}
										placeholder="Select a category"
										className={`selectpicker p-0 ${errors.category_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
									/>
									{errors.category_id && <div className="invalid-feedback d-block">{errors.category_id.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Sub Category <span className="text-danger">*</span>
									</label>
									<Select
										{...register("sub_cat_id", {
											required: { value: true, message: "Select a sub category." },
										})}
										options={subCat?.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										value={selectedSubCat}
										onChange={(selected) => {
											setSelectedSubCat(selected);
											setValue("sub_cat_id", selected ? selected.value : "");
											trigger("sub_cat_id");
										}}
										placeholder="Select a sub category"
										className={`selectpicker p-0 ${errors.sub_cat_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
									/>

									{errors.sub_cat_id && <div className="invalid-feedback d-block">{errors.sub_cat_id.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Description <span className="text-danger">*</span>
									</label>

									<textarea
										className={`form-control ${errors.description && "is-invalid"}`}
										rows="5"
										placeholder="Description"
										{...register("description", {
											required: { value: true, message: "Description is required." },
										})}
									></textarea>
									{errors.description && <div className="invalid-feedback d-block">{errors.description.message}</div>}
								</div>
							</div>
							<div className="modal-footer d-block text-center border-0">
								<button className={`btn btn-default hover-up m-auto`} type="submit" name="Submit">
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateForum;
